import {Moment} from 'moment'

import {Iso8601} from './atomic.types'
import {User} from './shiftHandover.types'

export enum SapStatusCode {
  ON_GOING = 'OSNO', // Outstanding notification
  PENDING = 'NOPR', // Notification in process
  DONE = 'NOCO', // Notification completed
  SUBMITTED = 'Submitted',
  CREATED = 'ORAS' // Order assigned
}

export type SapDataDto = {
  sapStatusCode?: SapStatusCode
  sapMaintenanceNotificationId?: string
  lastMaintenanceNotificationCreationStart?: Iso8601
  sapMaintenanceNotificationCreator?: User
}

export type SapData = {
  sapStatusCode?: SapStatusCode
  sapMaintenanceNotificationId?: string
  lastMaintenanceNotificationCreationStart?: Moment
  sapMaintenanceNotificationCreator?: User
}
